import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { useTranslation } from 'react-i18next'
import Pagination from '../../../Pagination/Pagination'
import TableBackdrop from '../../../TableUI/TableBackdrop'
import TableActions from '../../../TableUI/TableActions'
import DatetimeValue from '../../../TableUI/DatetimeValue'
import ThumbDownIcon from '@mui/icons-material/ThumbDown'
import ThumbUpIcon from '@mui/icons-material/ThumbUp'
import { ST_LOCKED, ST_PRODUCTION } from '../../../../enums/MerchantPaymentMethods'
import { MERCHANT_PAYMENT_METHODS__UPDATE } from './../../../../enums/Caps'
import useHasPermissions from '../../../../hooks/useHasPermissions'


export default function MethodsRequestedTable({
    data,
    pages = 1,
    page = 1,
    loading = false,
    handleOnPageChange,
    handleChangeStatus
}) {
    const { t } = useTranslation()

    const hasPermissions = useHasPermissions()

    return (
        <>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>{t('Merchant')}</TableCell>
                            <TableCell>{t('Method')}</TableCell>
                            <TableCell>{t('Country')}</TableCell>
                            <TableCell align="center">{t('Requested at')}</TableCell>
                            {hasPermissions(MERCHANT_PAYMENT_METHODS__UPDATE) && (<TableCell align="right">&nbsp;</TableCell>)}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!loading && data.length ? data.map((row) => (
                            <TableRow
                                key={row.id}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell component="th" scope="row">
                                    {row.merchant?.username}
                                </TableCell>
                                <TableCell>{row.payment_method_name}</TableCell>
                                <TableCell>{row.country}</TableCell>
                                <TableCell align="center">
                                    <DatetimeValue date={row.created_at} />
                                </TableCell>
                                {hasPermissions(MERCHANT_PAYMENT_METHODS__UPDATE) && (<TableCell align="right">
                                    <TableActions actions={[
                                        {
                                            id: `confirm-${row.id}`,
                                            handleClick: () => { handleChangeStatus(row.id, ST_PRODUCTION) },
                                            icon: <ThumbUpIcon />,
                                            title: t('Confirm')
                                        },
                                        {
                                            id: `reject-${row.id}`,
                                            handleClick: () => { handleChangeStatus(row.id, ST_LOCKED) },
                                            icon: <ThumbDownIcon />,
                                            title: t('Reject')
                                        }
                                    ]} />
                                </TableCell>)}
                            </TableRow>
                        )) : <TableRow>
                            {
                                loading ? <TableBackdrop open={loading} /> : <TableCell sx={{ textAlign: 'center' }} colSpan={100}>{t('No records found')}</TableCell>
                            }
                        </TableRow>
                        }
                    </TableBody>
                </Table>
            </TableContainer>

            <Pagination
                handleOnPageChange={handleOnPageChange}
                page={page}
                pages={pages}
            />
        </>
    )
}
